import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import UAParser from 'ua-parser-js';

const state = {
  lang: '',
  os: '',
  ua: null,
  isMobile: false,
  isFirst: false,
  isTop: false,
  isShowGnav: false,
  isShowLoading: false,
  isShowRefine: false,
  isShowRelatedSp: false,
  isShowCoverIn: false,
  isShowCoverOut: true,
  note: {},
  urls: {
    map: 'https://goo.gl/maps/XHnitQfx4CRHm3iC9',
    map_live: 'https://goo.gl/maps/XHnitQfx4CRHm3iC9',
    facebook: 'https://www.facebook.com/P.I.C.S.tokyo',
    twitter: 'https://twitter.com/pics_tokyo',
    insta: 'https://www.instagram.com/pics_tokyo/',
    youtube: 'https://www.youtube.com/@pics_tokyo',
    vimeo: 'https://vimeo.com/picsinc',
    official: 'https://www.fournines.co.jp/',
    page: {

    }
  },
  siteDomains: [
    'www.pics.tokyo',
    'preview.pics.tokyo',
    'picstokyo.xsrv.jp',
    'pics-wp.homun.net',
    'pics.local'
  ]
};

const mutations = {
  setOS(state) {
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf("mac os x") !== -1) {
      state.os = 'mac';
    }
  },
  setDevice(state) {
    const parser = new UAParser();
    const ua = parser.getResult();
    state.ua = ua;
    state.isMobile = false;

    if (ua.os.name === 'iOS' || ua.os.name === 'Android') {
      state.isMobile = true;
    } else if (ua.os.name === 'Mac OS') {
      state.os = 'mac';
    }
  },
  setFirst(state) {
    // 初回サイトアクセス判定
    state.isFirst = (document.referrer.indexOf(location.protocol + '//' + location.hostname) === -1);
  },
  setTop(state) {
    // TOPページ判定
    const classList = document.body.className.split(' ');
    if (classList.indexOf('p-page-top') > -1) {
      state.isTop = true;
    } else {
      state.isTop = false;
    }
  },
  setShowGnav(state, isShow) {
    state.isShowGnav = isShow;
  },
  setShowLoading(state, isShow) {
    state.isShowLoading = isShow;
  },
  setShowRefine(state, isShow) {
    state.isShowRefine = isShow;
  },
  setShowRelatedSp(state, isShow) {
    state.isShowRelatedSp = isShow;
  },
  setShowCoverIn(state, isShow) {
    state.isShowCoverIn = isShow;
  },
  setShowCoverOut(state, isShow) {
    state.isShowCoverOut = isShow;
  }
};

const getters = {
  getLang: (state) => {
    return state.lang;
  },
  getOS: (state) => {
    return state.os;
  },
  isMobile: (state) => {
    return state.isMobile;
  },
  getFirst: (state) => {
    return state.isFirst;
  },
  getTop: (state) => {
    return state.isTop;
  },
  isShowGnav: (state) => {
    return state.isShowGnav;
  },
  isShowLoading: (state) => {
    return state.isShowLoading;
  },
  isShowRefine: (state) => {
    return state.isShowRefine;
  },
  isShowRelatedSp: (state) => {
    return state.isShowRelatedSp;
  },
  isShowCoverIn: (state) => {
    return state.isShowCoverIn;
  },
  isShowCoverOut: (state) => {
    return state.isShowCoverOut;
  },
  getUrls: (state) => {
    return state.urls;
  },
  getDomains: (state) => {
    return state.siteDomains;
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations
});